/**
 * Returns envs from process.env (SSR) or global object (CSR).
 */

export default function(variableName) {
  let env = {};

  if (typeof window !== "undefined" && window.GLOBAL_UI_PUBLIC_ENV) {
    env = window.GLOBAL_UI_PUBLIC_ENV;
  } else if (typeof process !== "undefined") {
    ({ env } = process);
  }

  if (variableName) {
    return env[variableName];
  }

  return env;
}
